import { VanillaReaderRendererNames } from "../VanillaReader/VanillaReaderModel";
import { VanillaReaderAppMain } from "../VanillaReaderApp/VanillaReaderAppMain";

export class MasterPlanPostMessageHandler {

    private static _masterPlanPostMessageHandlerInstance: MasterPlanPostMessageHandler | undefined;

    private constructor(private _vanillaReaderAppMain: VanillaReaderAppMain) {
        this._vanillaReaderAppMain.onVanillaReaderInstanceCreated(()=>{
            const vanillaReader = this._vanillaReaderAppMain.getVanillaReaderInstance();
            if(!vanillaReader) {
                throw new Error('MasterPlanPostMessageHandler.constructor(): vanillaReaderAppMain.getVanillaReaderInstance() returned undefined.');
            }
        });
    }
    
    public static get instance(): MasterPlanPostMessageHandler | undefined {
        return MasterPlanPostMessageHandler._masterPlanPostMessageHandlerInstance;
    }

    public static create(appMain: VanillaReaderAppMain): MasterPlanPostMessageHandler {
        MasterPlanPostMessageHandler._masterPlanPostMessageHandlerInstance = new MasterPlanPostMessageHandler(appMain);
        
        window.addEventListener("message", this._processPostMessage);
        return MasterPlanPostMessageHandler._masterPlanPostMessageHandlerInstance!;
    }


    private static _processPostMessage = (message: MessageEvent) => {
      if (!message.origin.includes('masterplan')) return;
      console.log(`>>> Colibrio (${message.data.type})`);

        switch (message.data.type) {
            case 'LOAD_PUBLICATION_URL':
                this.instance?._vanillaReaderAppMain.getVanillaReaderApiInstance()?.loadPublicationFromUrl(message.data.value, undefined, true);
                break;
            case 'LOAD_PUBLICATION_BLOB':
                this.instance?._vanillaReaderAppMain.getVanillaReaderApiInstance()?.loadPublicationFromFile(message.data.value, undefined, true);
                break;
            case 'INITIAL_LOCATION':
                this.instance?._vanillaReaderAppMain.getVanillaReaderApiInstance()?.goTo(message.data.value);   
                break;
            case 'SPREAD_ACCESS':
                console.log("COLIBRIO Spread Access: ", message.data.value);
                this.instance?._vanillaReaderAppMain.getVanillaReaderApiInstance()?.setRenderableDocuments(message.data.value);
                break;
            case 'GOTO':
                const waitForLoaded = new Promise((resolve, _) => {
                    const loop = () => this.instance?._vanillaReaderAppMain.getVanillaReaderInstance()?.isLoaded !== undefined && this.instance?._vanillaReaderAppMain.getVanillaReaderInstance()?.isLoaded ? resolve(true) : setTimeout(loop)
                    loop();
                });
                waitForLoaded.then(()=>this.instance?._vanillaReaderAppMain.getVanillaReaderApiInstance()?.goTo(message.data.value));
                break;
            case 'SET_RENDERER':
                console.log("COLIBRIO Set Renderer: ", message.data.value);
                //readerModel.initialState.publication.renderer = message.data.value;
                //GlobalEventBus.$emit(GlobalEventName.READER_RENDERER_CHANGE_INTENT, message.data.value);
                break;
            case 'FORCE_RENDERER':
                let renderer: VanillaReaderRendererNames;
                switch (message.data.value){
                    case 'verticalScrollRenderer':
                        renderer = VanillaReaderRendererNames.SCROLL
                    break;
                    case 'stackRenderer':
                        renderer = VanillaReaderRendererNames.STACK
                    break;
                    case 'flipbookRenderer':
                        renderer = VanillaReaderRendererNames.FLIPBOOK
                    break;
                    case '__responsive':
                        renderer = VanillaReaderRendererNames.RESPONSIVE
                    break;
                    default:
                        renderer = VanillaReaderRendererNames.RESPONSIVE

                }
                console.log("COLIBRIO Force Renderer: ", message.data.value);
                this.instance?._vanillaReaderAppMain.getVanillaReaderApiInstance()?.changeRenderer(renderer, true);
                break;
            case 'SEARCH_COLIBRIO':
                console.log("COLIBRIO Search: ", message.data.value);
                let term = (typeof message.data.value !== 'undefined') ? message.data.value : "";
                this.instance?._vanillaReaderAppMain.getVanillaReaderApiInstance()?.searchPublication(term, 1000);
                break;
            case 'CLEAR_SEARCH_COLIBRIO':
                console.log("COLIBRIO Clear Search");
                this.instance?._vanillaReaderAppMain.getVanillaReaderApiInstance()?.clearPublicationSearchLayer();
                break;
            case 'SEARCH_COLIBRIO_AND_NAVIGATE':
                console.log("COLIBRIO Search and Navigate: ", message.data.value);
                break;
            case 'FORCE_ASPECT_RATIO':
                console.log("COLIBRIO Force Aspect Ratio: ", message.data.value);
                //readerModel.initialState.publication.ignoreAspectRatio = (message.data.value == "true");
                //GlobalEventBus.$emit("masterplan-force-aspect-ratio", (message.data.value == "true"));
                break;
            case 'READER_PUBLICATION_LOADED':
                break;
            case 'STOP_MEDIA':
                console.log("COLIBRIO Stop Media: ", message.data.value);
                //GlobalEventBus.$emit(GlobalEventName.STOP_SYNC_MEDIA_PLAYBACK, true);
                break;
            case 'ADD_ANNOTATION':
                console.log("COLIBRIO Add Annotation ", message.data.value);
                this.instance?._vanillaReaderAppMain.getVanillaReaderApiInstance()?.createAnnotationLayer(message.data.value);
                break;
            default:
        }
    }

    
}